<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>お利息のご案内</HeadingOne>
    <p>お借り入れ利率（実質年率）や、お利息の計算方法を詳しくご説明します。</p>

    <section>
      <HeadingTwo>お借り入れ利率について</HeadingTwo>
      <div class="contents-box _mb-md-30 _mb-sm-30">
        <div class="txt-box _mr-md-20">
          <p>
            au PAY
            スマートローンのお借り入れ利率（実質年率）は、2.9％～18.0％です。
          </p>
          <p class="_mb-md-60 _mb-sm-40">
            なお、お借り入れ利率（実質年率）は、審査後にご提示させていただきます。
          </p>
        </div>
        <CardBox class="_ml-md-20">
          <CardHeader>お借り入れ利率（実質年率）</CardHeader>
          <CardBody>
            <p class="txt01">
              実質年率<span class="txt02">&nbsp;2.9％～18.0％</span>
            </p>
            <ListGroup class="-note">
              <ListItem class="-note -textcenter"
                >ご利用限度額が100万円の場合、2.9%～15.0％</ListItem
              >
            </ListGroup>
          </CardBody>
        </CardBox>
      </div>

      <BtngroupSingle class="-margin-lg">
        <template v-if="isWebView()">
          <BtnMain class="-main" href="/entry/agreement">
            新規お申し込みはこちら
          </BtnMain>
        </template>
        <template v-else>
          <BtnMain class="-main" router-name="en001">
            新規お申し込みはこちら
          </BtnMain>
        </template>
      </BtngroupSingle>

      <HeadingThree>お利息の計算方法</HeadingThree>

      <p>
        お利息は、ご利用残高（元金）とお借り入れ利率（実質年率）、ご返済までの日数で計算します。
      </p>

      <NoticeBox class="-point _mb-md-40 _mb-sm-20">
        <div class="txt-box">
          <span class="bg-box01 _mr-md-25 _mr-sm-5">お利息</span>＝<span
            class="bg-box02 _ml-md-25 _ml-sm-5"
            >ご利用残高（元金）×お借り入れ利率（実質年率）÷365×日数</span
          >
        </div>
      </NoticeBox>
      <p class="-textcenter">
        例）お借り入れ利率（実質年率）15.0%で4万円借りたとき<br
          class="-pcnone"
        /><b class="_ml-md-30">1日当たり4万円×0.15 ÷365日≒16 円</b>
      </p>

      <div class="card-groups _mb-md-60 _mb-sm-40">
        <div class="card-box _mr-sm-10">
          <div class="card-body">1週間で支払うお利息は</div>
          <div class="triangle-bottom _mb-md-30 _mb-sm-20"></div>
          <div class="card-image">
            <div class="-leftimg _ml-md-80 _mb-sm-15">
              <img
                src="@/assets/images/sv/sv022/img01.gif"
                class="img-fluid"
                alt=""
              />
            </div>
            <div class="txt01 _mb-sm-20">
              お利息<span class="-primary _ml-5">約</span
              ><span class="-primary -font">115</span
              ><span class="-primary">円</span><br />
              <span class="txt02">缶コーヒー約1本分相当</span>
            </div>
          </div>
        </div>
        <div class="card-box _ml-sm-10">
          <div class="card-body">30日で支払うお利息は</div>
          <div class="triangle-bottom _mb-md-30 _mb-sm-20"></div>
          <div class="card-image">
            <div class="-rightimg _ml-md-30 _mb-sm-15">
              <img
                src="@/assets/images/sv/sv022/img02.gif"
                class="img-fluid"
                alt=""
              />
            </div>
            <div class="txt01 _mb-sm-20">
              お利息<span class="-primary _ml-5">約</span
              ><span class="-primary -font">493</span
              ><span class="-primary">円</span><br />
              <span class="txt02">牛丼約1杯分相当</span>
            </div>
          </div>
        </div>
      </div>

      <p>
        ※ au PAY
        スマートローンのご返済方式は、「元利均等定額の借入時残高スライドリボルビング方式」となっております。<br />
        上記は一括でご返済いただいた場合の例となります。
      </p>
      <ListGroup class="-note">
        <ListItem class="-note"
          >毎月ご返済日にご返済いただいた場合のお利息については、ご返済シミュレーションにてご確認ください。</ListItem
        >
        <ListItem class="-note"
          >お借り入れの当日はご利用日数に含まれません</ListItem
        >
        <ListItem class="-note"
          >お利息の計算では、1円未満端数切捨てとなります。</ListItem
        >
        <ListItem class="-note"
          >お借り入れ時がうるう年の場合は366日での計算となります。</ListItem
        >
      </ListGroup>
    </section>

    <section>
      <HeadingTwo>ご返済シミュレーション</HeadingTwo>
      <p>
        毎月のご返済額やご返済期間は、最終のお借り入れ時のご利用残高に応じて自動的に決定します。
      </p>
      <p>
        毎月のご返済額やご返済期間について知りたい場合は、「ご返済シミュレーション」をお試しください。
      </p>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal" router-name="sv052"
          >ご返済シミュレーションへ</BtnMain
        >
      </BtngroupSingle>
    </section>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import HeadingThree from "@/components/heading/HeadingThree";
import CvBox from "@/components/box/CvBox";
import ContactBox from "@/components/box/ContactBox";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import NoticeBox from "@/components/box/NoticeBox";
// import NoticeBody from '@/components/box/NoticeBody'
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "@/components/card/CardBody";
import { isWebView } from "@/utils/UserAgent";

export default {
  name: "Sv022",
  components: {
    BreadcrumbGroup,
    CardBody,
    CardHeader,
    CardBox,
    ListItem,
    ListGroup,
    // NoticeBody,
    NoticeBox,
    BtnMain,
    BtngroupSingle,
    ContactBox,
    CvBox,
    HeadingThree,
    HeadingOne,
    HeadingTwo,
  },
  setup() {
    setMeta({
      title: "お利息のご案内｜お借り入れについて",
      description:
        "お借り入れ利率、お利息の計算方法についてご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,利息",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お借り入れについて",
          routerName: "sv046",
        },
        {
          text: "お利息のご案内",
          active: true,
        },
      ],
      check: {
        expectation: "",
      },
    };
  },
  methods: {
    isWebView: function () {
      return isWebView();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-box {
  @include mq-up(md) {
    display: flex;
    align-items: flex-start;
  }
  > .card-box {
    max-width: 580px;
    width: 100%;
    border: 1px solid #cccccc;
    border-radius: 10px;
    font-size: 20px;
    border-radius: 10px;
    > .card-header {
      background: $dark;
      text-align: center;
      color: #fff;
      font-weight: normal;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    > .card-body {
      > .txt01 {
        font-size: 14px;
        text-align: center;
        color: $orange;
        font-weight: bold;
        padding-top: 30px;
        @include mq-up(md) {
          font-size: 28px;
        }
        > .txt02 {
          font-size: 19px;
          @include mq-up(md) {
            font-size: 38px;
          }
        }
      }
    }
  }
}
.notice-box {
  text-align: center !important;
  > .txt-box {
    font-size: 14px;
    color: $orange;
    @include mq-down(md) {
      display: flex;
      align-items: center;
      text-align: left;
    }
    @include mq-up(md) {
      font-size: 28px;
      line-height: 34px;
    }
    > .bg-box01 {
      background-color: $orange;
      color: $white;
      text-align: center;
      padding: 10px;
      display: inline-block;
      border-radius: 10px;
      font-weight: bold;
      @include mq-up(md) {
        padding: 15px 40px;
      }
    }
    > .bg-box02 {
      border: 1px solid $orange;
      border-radius: 10px;
      padding: 9px;
      display: inline-block;
      font-weight: bold;
      @include mq-up(md) {
        padding: 14px 39px;
      }
    }
  }
  > .notice-body {
    @include mq-down(md) {
      text-align: left;
    }
  }
}

.card-groups {
  display: flex;
  justify-content: space-between;
  @include mq-up(md) {
    max-width: 960px;
    margin: 0 auto;
  }
  > .card-box {
    width: 50%;
    @include mq-down(md) {
      display: flex;
      flex-direction: column;
    }
    @include mq-up(md) {
      max-width: 420px;
      width: 100%;
    }
    > .card-body {
      background-color: $light;
      text-align: center;
      padding-top: 10px;
      padding-bottom: 10px;
      border-radius: 10px;
      @include mq-up(md) {
        padding-top: 20px;
        padding-bottom: 20px;
      }
    }
    > .triangle-bottom {
      display: inline-block;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 15px 7.5px 0 7.5px;
      border-color: $light transparent transparent transparent;
      display: block;
      margin: 0 auto;
      @include mq-up(md) {
        border-width: 20px 12.5px 0 12.5px;
      }
    }
    > .card-image {
      display: flex;
      align-items: center;
      @include mq-down(md) {
        justify-content: center;
        flex-wrap: wrap;
      }
      @include mq-up(md) {
        justify-content: space-between;
      }
      &.-width80 {
        max-width: 62%;
      }
      &.-width90 {
        max-width: 90%;
      }
      &.-width100-sp {
        @include mq-down(md) {
          max-width: 100%;
        }
      }
      > .-leftimg {
        max-width: 50px;
        width: 100%;
        @include mq-up(md) {
          max-width: 65px;
        }
      }
      > .-rightimg {
        max-width: 110px;
        width: 100%;
        @include mq-up(md) {
          max-width: 159px;
        }
      }
      > .txt01 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        @include mq-down(md) {
          margin-top: auto;
        }
        @include mq-up(md) {
          font-size: 18px;
        }
        > .txt02 {
          font-size: 14px;
          @include mq-up(md) {
            font-size: 16px;
          }
        }
        > .-primary {
          color: $primary;
        }
        > .-font {
          font-size: 21px;
          font-weight: bold;
          @include mq-up(md) {
            font-size: 30px;
          }
        }
      }
    }
  }
}
</style>
